// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[data-v-039ed65b]:root{font-size:10px}.logoContainer[data-v-039ed65b]{transition:fill .5s ease-in-out}.white[data-v-039ed65b]{fill:#fff}.black[data-v-039ed65b]{fill:#3f4b40}.green[data-v-039ed65b]{fill:#49e4ad}.gray[data-v-039ed65b]{fill:#8c938c}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
